<template>
  <el-card class="box-card mt-3" id="price-list">
    <div slot="header" class="clearfix">
      <span><h4>Bảng giá</h4></span>
    </div>
    <div v-if="infomation" v-html="infomation.course">
    </div>
    <div v-else>Chưa có bảng giá</div>
  </el-card>
</template>

<script>
export default {
  name: "PriceList",
  props: {
    infomation: {},
  }
}
</script>

<style scoped>

</style>